/** Primitivas visuais reutilizadas nas telas admin. */

export function Loading({ label = 'Carregando…' }: { label?: string }) {
  return (
    <div className="card flex items-center justify-center gap-3 px-6 py-16 text-sm text-ink-3">
      <span
        className="h-4 w-4 animate-spin rounded-full border-2 border-line-2 border-t-transparent"
        style={{ borderTopColor: 'var(--accent-bright)' }}
      />
      {label}
    </div>
  );
}

export function ErrorBox({ msg, onRetry }: { msg: string; onRetry?: () => void }) {
  return (
    <div
      className="rounded px-5 py-4 text-sm"
      style={{ border: '1px solid var(--risk)', background: 'var(--risk-soft)', color: 'var(--ink-2)' }}
    >
      <div className="font-medium text-ink">Não foi possível carregar</div>
      <div className="mt-1 text-ink-3">{msg}</div>
      {onRetry && (
        <button className="btn btn-ghost mt-3" onClick={onRetry}>
          Tentar de novo
        </button>
      )}
    </div>
  );
}

export function EmptyBox({
  titulo,
  descricao,
  children,
}: {
  titulo: string;
  descricao: string;
  children?: React.ReactNode;
}) {
  return (
    <div className="card px-6 py-16 text-center">
      <div className="text-base font-semibold text-ink">{titulo}</div>
      <div className="mx-auto mt-2 max-w-sm text-sm text-ink-3">{descricao}</div>
      {children && <div className="mt-5 flex flex-wrap items-center justify-center gap-3">{children}</div>}
    </div>
  );
}

export function KpiCard({
  label,
  valor,
  sub,
  destaque,
}: {
  label: string;
  valor: React.ReactNode;
  sub?: React.ReactNode;
  destaque?: boolean;
}) {
  return (
    <div className="card p-[22px]">
      <div className="text-xs font-medium text-ink-3">{label}</div>
      <div
        className="num mt-2 font-serif text-[34px] font-medium leading-none tracking-tight"
        style={{ color: destaque ? 'var(--accent)' : 'var(--ink)' }}
      >
        {valor}
      </div>
      {sub && <div className="mt-1.5 text-xs text-ink-3">{sub}</div>}
    </div>
  );
}

export function StatusPill({ label, color }: { label: string; color: string }) {
  return (
    <span className="inline-flex items-center gap-2 text-[13px] font-medium" style={{ color }}>
      <span className="h-2 w-2 shrink-0 rounded-full" style={{ background: color }} />
      {label}
    </span>
  );
}

export function PageTitle({ titulo }: { titulo: string }) {
  return (
    <div className="mb-6">
      <h1 className="font-serif text-[34px] font-medium tracking-tight text-ink">{titulo}</h1>
    </div>
  );
}

/** Interruptor on/off simples (ex.: overrides por org no console admin). */
export function Toggle({
  ligado,
  onChange,
  disabled,
  label,
}: {
  ligado: boolean;
  onChange: () => void;
  disabled?: boolean;
  label: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={ligado}
      aria-label={label}
      onClick={onChange}
      disabled={disabled}
      className="relative h-6 w-11 shrink-0 overflow-hidden rounded-full transition-colors disabled:opacity-60"
      style={{ background: ligado ? 'var(--accent)' : 'var(--line-2)' }}
    >
      <span
        className="absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform"
        style={{ transform: ligado ? 'translateX(20px)' : 'translateX(0)' }}
      />
    </button>
  );
}
